import { z } from 'zod';
import { syncBookkeepingSchema, uuidSchema } from './base.js';

export const commentSchema = syncBookkeepingSchema.extend({
  id: uuidSchema,
  task_id: uuidSchema,
  body: z.string().min(1).max(10_000),
});

export type Comment = z.infer<typeof commentSchema>;

export const commentCreateSchema = commentSchema.pick({ id: true, task_id: true, body: true });
export const commentPatchSchema = commentSchema.pick({ body: true }).partial();

export type CommentCreate = z.infer<typeof commentCreateSchema>;
export type CommentPatch = z.infer<typeof commentPatchSchema>;
